<template>
  <v-container fluid pa-0>
    <DuwaTable />
  </v-container>
</template>

<script>
import DuwaTable from '@/modules/duwa/components/DuwaTable'

export default {
  name: 'Duwa',

  components: {
    DuwaTable
  }
}
</script>
